<div class="popup-overlay">
  <div class="popup-box">
    <!-- <span class="title">Comment</span> -->
    <div class="each-div">
      <!-- <span class="drop-title">Verify Otp*</span> -->
      <textarea name="comment" id="comment" placeholder="Comment*" class="comment-txt"
        [formControl]="comment"></textarea>
      <label class="cb" *ngIf="role === 'ADMIN'">
        <input type="checkbox" (change)="Checked()" [(ngModel)]="isChecked">
        <span class="box"></span>
        <span class="hint">Mark as
        <div class="heading status-resolved-font">
                <div class="nibble status-adminPending-font">RESOLVED</div>
        </div>   
        </span>
      </label>
    </div>
    <div class="btn-div">
      <button class="ac-danger-btn" (click)="close()">Cancel</button>
      <button class="ac-primary-btn" (click)="updateComment()">Submit & Exit</button>
    </div>
  </div>
</div>

<app-loading [isLoading]="isLoading"></app-loading>